"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReportFeedbackInput = instanceOfReportFeedbackInput;
exports.ReportFeedbackInputFromJSON = ReportFeedbackInputFromJSON;
exports.ReportFeedbackInputFromJSONTyped = ReportFeedbackInputFromJSONTyped;
exports.ReportFeedbackInputToJSON = ReportFeedbackInputToJSON;
/**
 * Check if a given object implements the ReportFeedbackInput interface.
 */
function instanceOfReportFeedbackInput(value) {
    if (!('comment' in value) || value['comment'] === undefined)
        return false;
    if (!('rate' in value) || value['rate'] === undefined)
        return false;
    return true;
}
function ReportFeedbackInputFromJSON(json) {
    return ReportFeedbackInputFromJSONTyped(json, false);
}
function ReportFeedbackInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'comment': json['comment'],
        'rate': json['rate'],
    };
}
function ReportFeedbackInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'comment': value['comment'],
        'rate': value['rate'],
    };
}
